import { set, toggle } from '@/utils/vuex'

export default {
  namespaced : true,
  // state
  state : {
      skin : 'dok',
      drawer: null,
      showUserSettings : false,
      merkato: {
        show: false,
        load: false, 
        m_url : null,
        initializeError : false,
      },
      dossier: {
        show: false
      },
      color: "primary",
      form: {
        hasChange: false,
        show: false,
        disabled: false,
        email: "",
        phone: ""
      },
      contract: {
        hasChange: false,
        loading: false,
        valid: false
      },
      details: {
        show: false
      },
      settings: {
        change: false,
        count_objects: 0
      },
      contracts: {
        loading: false
      },
      objects: {
        loading: false
      },
      organisation : {
        managed_list : []
      }, 
      selected : [],
      userSettingsPanel : [],
  }, 

  mutations : {
    setDrawer: set('drawer'),
    setImage: set('image'),
    setColor: set('color'),
    toggleDrawer: toggle('drawer'),
    toggleUserSettings : toggle('showUserSettings'), 
    resetChange (state) {
      state.settings.change = false
    }, 
    setChange (state) {
      state.settings.change = true
    }, 
    clearUserSettingsPanel (state){
      state.userSettingsPanel = []
    }, 
    merkatoError(state) {
      state.merkato.load = false; 
      state.merkato.show = false;
      state.merkato.initializeError = true;
    },
    setMerkatoUrl(state,  payload) {
      state.merkato.m_url = payload
      state.merkato.load = false;
      state.merkato.show = true;
    }
  }



};
